import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  viewAllLink?: string;
  viewAllLabel?: string;
  accent?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  viewAllLink,
  viewAllLabel,
  accent = "orange",
}: SectionHeaderProps) {
  const { t } = useTranslation();
  const label = viewAllLabel ?? t("section.viewAll.label");

  const accentColors: Record<string, string> = {
    orange: "bg-orange-500",
    green: "bg-green-600",
    yellow: "bg-yellow-500",
    pink: "bg-pink-500",
    purple: "bg-purple-500",
  };

  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
      <div className="flex-1 min-w-0">
        <div className={`w-10 h-1 rounded-full mb-3 ${accentColors[accent] || accentColors.orange}`}></div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{title}</h2>
        {subtitle && <p className="text-gray-500 mt-1 text-sm md:text-base">{subtitle}</p>}
      </div>
      {viewAllLink && (
        <Link
          to={viewAllLink}
          className="flex-shrink-0 flex items-center gap-2 text-sm font-semibold text-orange-500 hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}
